export { default as getChangePasswordFormConfig } from './get-change-password-form-config';
export { default as getDialogFormConfig } from './get-dialog-form-config';
export { default as getFreeConsultationFormConfig } from './get-free-consultation-form-config';
export { default as getPaymentFormConfig } from './get-payment-form-config';
export { default as getProfileEmailFormConfig } from './get-profile-email-form-config';
export { default as getSearchPostFormConfig } from './get-search-post-form-config';
export { default as getSubscriptionFormConfig } from './get-subscription-form-config';
export { default as getUserProfileFormConfig } from './get-user-profile-form-config';
